import React from "react";
import ReactDOM from "react-dom";
// STYLE
import "./styles/index.scss";
import "./index.css";
import "./styles/myStyle.css";
import "./fonts/line-awesome-1.3.0/css/line-awesome.css";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "functions/redux/store";

if (typeof window !== 'undefined') {
    const originalWarn = console.warn;
    console.warn = (...args: any[]) => {
        if (
            typeof args[0] === 'string' &&
            (args[0].includes('google.maps.places.AutocompleteService') ||
             args[0].includes('componentWillReceiveProps has been renamed'))
        ) {
            return;
        }
        originalWarn.apply(console, args);
    };

    const removeErrorOverlay = () => {
        const iframes = document.querySelectorAll('iframe[style*="2147483647"]');
        iframes.forEach((el) => el.remove());
    };
    window.addEventListener('error', (event) => {
        if (event.message && (event.message.includes('startTime') || event.message.includes('Cannot read properties of undefined'))) {
            event.preventDefault();
            event.stopImmediatePropagation();
        }
        removeErrorOverlay();
    });
    window.addEventListener('unhandledrejection', removeErrorOverlay);
}

ReactDOM.render(
        <Provider store={store}>
                <App />
        </Provider>,
        document.getElementById("root"));
